import React from "react";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import ContactHero from "../Components/contact/ContactHero";
import ContactFormInfo from "../Components/contact/ContactFormInfo";
import ContactLocation from "../Components/contact/ContactLocation";

// Redesigned (Tailwind) page for /contact-us.
const ContactPage = () => (
  <div>
    <SEOPage
      title="Contact DataMetricks Consulting Pvt Ltd | Get in Touch with Us Today"
      description="Looking to start a project or have questions? Contact DataMetricks Consulting Pvt Ltd for expert website design, development, and digital marketing solutions. We're here to help!"
      canonicalUrl="https://www.datametricks.com/contact-us"
    />

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <ContactHero />
      <ContactFormInfo />
      <ContactLocation />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default ContactPage;
